import * as Sentry from '@sentry/react';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { 
  Button, 
  Modal, 
  Typography,
  IconButton
} from '@mui/material';
import { 
  Close 
} from '@mui/icons-material';
import { styled as muiStyled } from '@mui/material/styles';
import COLOR from 'utils/constants/color';
import Loading from "components/Loading";
import styled from 'styled-components';
import { Avatar, Col, Row, Tooltip } from 'antd';
import { chunk, get, map, filter } from "lodash";
import { handleSyncCoteacher } from 'store/clever/thunks';
import { handleCreateOrUpdateClassConfig, handleListUserClasses, handleHideShowClasses } from "store/userClasses/thunks";
import { handleGetClass, handleUpdateClass } from "store/classes/thunks";
import { useCurrentUser } from 'store/users/selectors';
import { DeleteModal } from './Dialog';
import { classCardHandleStudentSync } from "./classCardHandleStudentSync";
import {
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596,
    IMG_7600,
    IMG_7605,
    IMG_7611,
    IMG_7614,
    TransparentLogoWhite,
} from 'utils/assets/images';
import useGetStudentFromClass from './hooks/useGetStudentFromClass/useGetStudentFromClass';
import cardEditSvg from "../utils/assets/images/card-edit.svg";
import ChangeAvatarSvg from "../utils/assets/images/ChangeAvatar.svg";
import ChangeThemePng from "../utils/assets/images/ChangeTheme.png";
import crossCircleSvg from "../utils/assets/images/cross-circle.svg";
import OneWayLogoSvg from "../utils/assets/images/OneWayLogo.svg";

const THEME = [
    'linear-gradient(90deg, #5270fc, #5270fc 100%, #ffffff)',
    'linear-gradient(90deg, #fc9e19, #fc9e19 100%, #ffffff)',
    'linear-gradient(90deg, #002d75, #002d75 100%, #ffffff)',
    'linear-gradient(90deg, #00bdab, #00bdab 100%, #ffffff)',
    'linear-gradient(90deg, #7c2ae8, #7c2ae8 100%, #ffffff)',
    'linear-gradient(90deg, #05c1c9, #05c1c9 100%, #ffffff)',
    'linear-gradient(90deg, #ff6347, #ff6347 100%, #ffffff)',
    'linear-gradient(90deg, #3cb371, #3cb371 100%, #ffffff)',
    'linear-gradient(90deg, #8a0309, #8a0309 100%, #ffffff)',
    'linear-gradient(90deg, #ee82ee, #ee82ee 100%, #ffffff)',
    'linear-gradient(90deg, #ff0000, #ff0000 100%, #ffffff)',
    'linear-gradient(90deg, #ffc0cb, #ffc0cb 100%, #ffffff)',
]
const AVATARS = {
    IMG_7614,
    IMG_7611,
    IMG_7605,
    IMG_7600,
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596
}
const dummyPicture = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FdummyPicture.png?alt=media&token=1354d5b3-b159-401e-aac8-122e76009c06`

const UserModal = styled.div`
left: 50%;
max-width: 85vw;
position: absolute;
top: 50%;
transform: translate(-50%, -50%);
width: 100%;
@media screen and (max-width: 768px){
    max-width: 95vw;
}
`;
const UserPopUpArea = styled.div`
background-color: rgb(82,84,82);
border-radius: 10px;
padding: 28px;
position:relative;
display: flex; 
flex-direction: column;
@media screen and (max-width: 768px){
    padding: 15px;
}
`;
const CloseBtn = styled.div`
border: none;
cursor: pointer;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
width: 30px;
height: 30px;
border-radius: 50%;
position: absolute;
top: 0px;
right: 0px;
color: white;
z-index: 1;
`;
const UserArea = styled.div`
display:flex;
flex-direction:column;
overflow:auto;
overflow-x:auto;
width: 100%;
display:flex;
flex-wrap: wrap;
flex-direction:row;
align-items: center;
justify-content: center;
`;
const Wrapper = styled.div`
cursor: pointer;
border: ${p => p.active ? ` 2px solid green` : 'none'};
padding: 4px;
flex-direction: row;
padding: 2px;
border-radius: 50%;
margin:${p => p.active ? ` 18px` : '20px'};
justify-content: center;
align-items: center;
display: flex;
flex-direction: row;
position:relative;
@media screen and (max-width: 768px){
    margin:${p => p.active ? ` 4px` : '6px'};
}
`;
const Logo = styled.img`
height: auto;
width: 100px;
`;
const LogoBottomRow = styled.div`
display: flex;
flex-direction: row;
justify-content: flex-end;
width:100%;
`;
const LoaderWrapper = styled.div`
position:absolute;
z-index:100;
`;
const ImageRow = styled.div`
display: flex;
flex-wrap: wrap;
align-items: center;
justify-content: center;
`;
const ColorCircle = styled.li`
   background:${p => p.bgColor ? p.bgColor : THEME[0]};
   cursor: pointer;
`;
const CardItem = styled.div`
background:${p => p.bgColor ? p.bgColor : THEME[0]};
`;
const NoteText = styled.span`
    margin-left: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
`;
const CoTeacherText = styled.div`
    font-size: 14px;
    font-weight: 500;
    color:#fff;
    text-transform: capitalize;
`;
const CoteacherTitle = styled.span`
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
`;
const OuterWrapper = styled.div`
   cursor: grabbing;
   background-color: #fff;
   ${'' /* width:400px; */}
  ${'' /* @media (max-width: 400px) {
    padding-bottom:100%;
  } **/}
    // min-width:300px;
    // @media only screen and (max-width: 576px) {
    //     margin: 0px 12px;
    //     width: calc(100% - 24px);
    // }
    // @media only screen and (min-width: 576px) and (max-width: 992px){
    //     margin: 0px 12px;
    //     width: calc(50% - 24px);
    // }
    // @media only screen and (min-width: 992px) and (max-width: 1200px){
    //     margin: 0px 12px;
    //     width: calc(33.33% - 24px);
    // }
    // @media only screen and (min-width: 1200px) {
    //     margin: 0px 12px;
    //     width: calc(25% - 24px);
    // }


`;
const StyledModal = muiStyled(Modal)({
  height: '100%',
  width: '100%',
  backgroundColor: 'transparent',
});

const StyledTypography = muiStyled(Typography)(({ theme }) => ({
  fontWeight: 400,
  color: 'rgb(255, 255, 255)',
  fontSize: 20,
  display: 'flex',
  flexDirection: 'row',
  marginBottom: 17,
}));

const StyledButton = muiStyled(Button)(({ theme }) => ({
  color: 'inherit',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));

const StyledIconButton = muiStyled(IconButton)(({ theme }) => ({
  color: 'inherit',
  padding: '8px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));

export default function ClassCard({ classInfo }) {
    const currentUser = useCurrentUser();
    const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
    const isCleverUser = !!(currentUser && currentUser.cleverId);
    const isCanvasUser = !!(currentUser && currentUser.canvas_id);
    const isGoogleUser = !!(currentUser && currentUser.googleId);
    const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
    const [visible, setVisible] = React.useState(false);
    const [editTitle, setEditTitle] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [displayName, setDisplayName] = useState('')
    const [avatarmodal, setAvatarModal] = useState(false)
    const [thememodal, setThemeModal] = useState(false)
    const [avatarSelected, setAvatarSelected] = useState(null)
    const [themeLoader, setThemeLoader] = useState(false)
    const [classLoader, setClassLoader] = useState(false)
    const [classGeadeLoader, setclassGeadeLoader] = useState(false)
    const [displaynameUpdate, setdisplaynameUpdate] = useState(false)
    const [theme, setTheme] = useState('')
    const [notes, setNotes] = useState('')
    const [loader, setLoader] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [archiveToggle,setArchiveToggle] = useState(false)
    const [onArchiveLoading,setOnArchiveloading] = useState(false)
    const [coteacherModal , setCoteacherModal] = useState(false)
    const classTeachers =  useMemo(()=>filter(get(classInfo,"teachers",[]),t=>t&&t.id!=currentUser.id),[currentUser,classInfo])
    const {getClassStudent} = useGetStudentFromClass();
    const getStudents = getClassStudent(classInfo.id);
    const studentCount = getStudents.length || null;
    const isUserFromOtherPlatform =  isSchoologyUser || isCleverUser || isGoogleUser || isClassLinkuser || isCanvasUser

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    useEffect(() => {
        setDisplayName(get(classInfo, "displayName", ''))
        setNotes(get(classInfo, "config.notes", ''))
        setAvatarSelected(get(classInfo, "config.avatar", ''))
        setTheme(get(classInfo, "config.theme", ''))
    }, [classInfo])

    // Sync co-teachers when modal opens
    useEffect(() => {
        const syncCoteachers = async () => {
            if (coteacherModal && isCleverUser && classInfo.cleverId && currentUser.cleverId && currentUser.id) {
                try {
                    const result = await dispatch(handleSyncCoteacher(
                        currentUser.cleverId,
                        classInfo.cleverId,
                        classInfo.id,
                        currentUser.id
                    ));
                    
                    if (result && result.success) {
                        console.log('Co-teachers synced successfully', result.data);
                    }
                } catch (error) {
                    console.error('Error syncing co-teachers:', error);
                    Sentry.captureException(`Error syncing co-teachers: ${error}`);
                }
            }
        };

        syncCoteachers();
    }, [coteacherModal, isCleverUser, classInfo.cleverId, classInfo.id, currentUser.cleverId, currentUser.id, dispatch])

    // Close modal if no co-teachers remain after sync
    useEffect(() => {
        if (coteacherModal && classTeachers.length === 0) {
            setCoteacherModal(false);
        }
    }, [coteacherModal, classTeachers.length])

    const updateAvatar = async (avatar) => {
        setLoader(true)
        setAvatarSelected(avatar)
        await dispatch(handleCreateOrUpdateClassConfig({ classId: classInfo.id, avatar: avatar }))
        setLoader(false)
        setAvatarModal(false)
        handleClose()
    }
    
    const onDisplayNameUpdate = async () => {
        if (ignoreBlurRef.current) {
            ignoreBlurRef.current = false; // reset after ignoring
            return; // Skip hiding if triggered by the edit icon
        }
    
        if (get(classInfo, "displayName", '') === displayName) {
            setEditTitle(false)
        } else {
            setEditTitle(false)
            await onUpdateClassName()
        }
        
    };
    
    const onUpdateClassName = async () => {
        setdisplaynameUpdate(true)
        await dispatch(handleUpdateClass(classInfo.id, { ...classInfo, displayName }))
        await dispatch(handleListUserClasses(currentUser.id))
        setdisplaynameUpdate(false)
    }
    const onThemeUpdate = async (_color) => {
        setTheme(_color)
        setThemeLoader(true)
        try {
            await dispatch(handleCreateOrUpdateClassConfig({ classId: classInfo.id, theme: _color }))
        } catch (error) {
            Sentry.captureException(`206 Error in update theme: ${error}`);
            console.log(error, "error in update theme")
        }
        setThemeModal(false)
        setThemeLoader(false)
        handleClose()
    }
    const onNotesDone = async () => {
        setVisible(false)
        try {
            await dispatch(handleCreateOrUpdateClassConfig({ classId: classInfo.id, notes }))
        } catch (error) {
            console.log(error, "error in update notes")
            Sentry.captureException(`205 Error in update notes: ${error}`);
        }
        setVisible(false)
    }
    const handleStudentSync = async () => {
        await classCardHandleStudentSync({ currentUser, classInfo, dispatch })
    }
    const redirectToHome = async () => {
        if (classGeadeLoader || classLoader) return;
        setClassLoader(true)
        try {
            await handleStudentSync()
            await dispatch(handleGetClass(classInfo.id));
            navigate(`/admin/class?view=home`, { replace: true });
        } finally {
            setClassLoader(false)
        }
    }
    const redirectToGradeBook = async () => {
        if (classGeadeLoader || classLoader) return;
        setclassGeadeLoader(true)
        try {
            await handleStudentSync()
            await dispatch(handleGetClass(classInfo.id));
            navigate(`/admin/class?view=gradebook`, { replace: true });
        } finally {
            setclassGeadeLoader(false)
        }
    }
    const onArchiveClass = () =>{
        setArchiveToggle(true)
    }
    const onArchiveDone = async () =>{
       setOnArchiveloading(true);
       await dispatch(handleHideShowClasses(currentUser.id,classInfo.id,!classInfo.archived))
       setOnArchiveloading(false);
       setArchiveToggle(false);
    }

    const combinedClassCode = `${get(classInfo, "displayName", '')} (${get(classInfo, "code", '')})`;
    const totalNameCode = combinedClassCode.length > 40 ? combinedClassCode.slice(0, 40) + '...' : combinedClassCode;

    const handleInputChange = (e) => {
        const maxLength = 60;
        const value = e.target.value;
        const trimmedValue = value.slice(0, maxLength);
        setDisplayName(trimmedValue);
    }

    const ignoreBlurRef = useRef(false);

    const handleEditClick = async () => {
        if (editTitle) {
          // Currently open, so we want to update and close
          ignoreBlurRef.current = true;
          setEditTitle(false);
          await onUpdateClassName();
        } else {
          // Opening it, no need to block blur
          ignoreBlurRef.current = false;
          setEditTitle(true);
        }
      };

    const textareaRef = useRef(null);
    useEffect(() => {
        if (editTitle && textareaRef.current) {
        const el = textareaRef.current;
        // Move cursor to the end
        el.selectionStart = el.selectionEnd = el.value.length;
        }
    }, [editTitle]); // Run this effect whenever editTitle changes

    return (
        <OuterWrapper className="userSection">
            <CardItem className="userHeader" bgColor={theme}>
                <div className="userHeadEdit userEditPen">
                    {!isUserFromOtherPlatform &&
                      <img src={cardEditSvg} alt="Card Edit" title="Card Edit"  
                        onClick={handleEditClick}
                        onMouseDown={() => (ignoreBlurRef.current = true)} // prevents blur
                      />
                    }
                </div>
                {editTitle && 
                <div className="newTitle">
                    <textarea 
                        ref={textareaRef}
                        autoFocus 
                        value={displayName} 
                        onChange={handleInputChange} 
                        onBlur={onDisplayNameUpdate}
                    >
                        Edit Title
                    </textarea>
                </div>}
                {!editTitle && 
                  <label> 
                    {displaynameUpdate && <Loading white size={15} />} 
                    <Tooltip className='breakTheSentence' title={combinedClassCode.length > 40 ? combinedClassCode : null}>
                        {totalNameCode}
                    </Tooltip>
                  </label>}
                <div className="userHeadPic">
                    <img src={AVATARS[avatarSelected] ? AVATARS[avatarSelected] : dummyPicture} />
                </div>
            </CardItem>
            <div className="noteSelf">
                <div className={`noteSelfInr ${classInfo.archived ? 'noteSelfInrArchived' : ''}`}>
                    <div className="noteSelfLeft 111">
                        {/* <div className='flex flex-col'>                          
                            <StyledButton onClick={() => setVisible(!visible)}>
                                Note to self:
                            </StyledButton>
                            {studentCount && <div className='studentCount'>Students: {studentCount}</div>}
                            <div className='archived-text'>
                                {classInfo.archived ? "(Archived)" : ""}
                            </div>
                        </div>
                        {visible ? 
                            <textarea 
                                placeholder={'Words..'} 
                                autoFocus 
                                value={notes} 
                                onChange={e => setNotes(e.target.value)} 
                                onBlur={onNotesDone}
                            /> : 
                            <NoteText className='noteTxtAply'>{notes}</NoteText>
                        } */}
                        {/* TODO : will be enable in furutue */}
                        {/* {studentCount && <label className='studentsEnrol'>{studentCount} Students enrolled</label>} */}
                    </div>
                    <div className="changeOption noteSelfRght">
                        {/* <MoreVertIcon aria-describedby={id} onClick={handleClick} />
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            disableScrollLock={true}
                        >
                            <div className="chngOptList">
                                <ul>
                                    <li><a className="mouseOverGrab" onClick={() => setAvatarModal(true)}>Change Avatar</a></li>
                                    <li><a className="mouseOverGrab" onClick={() => setThemeModal(true)}>Change Theme</a></li>
                                </ul>
                            </div>
                        </Popover> */}
                        <ul className='changeInfo'>
                            <li><img src={ChangeAvatarSvg} onClick={() => setAvatarModal(true)} alt="Change Avatar" title="Change Avatar" /></li>
                            <li><img src={ChangeThemePng} onClick={() => setThemeModal(true)} alt="Change Theme" title="Change Theme" /></li>
                        </ul>
                    </div>
                </div>
 
                {/* Avatar Modal */}
                <StyledModal
                    open={avatarmodal}
                    onClose={() => setAvatarModal(false)}
                    className="avtarModl avtarModlAddOns"
                >
                    <UserModal className="avtarUsrModl">
                        <UserPopUpArea className="avtarUsrArea">
                            <StyledTypography variant="h4">
                                Please select your avatar:
                            </StyledTypography>
                            <img src={crossCircleSvg} alt="Close" title="Close" onClick={() => setAvatarModal(false)} className='avtarMdlClose' />
                            <UserArea className="avtarUsrImg">
                                {chunk(Object.keys(AVATARS)).map((item, i) => (<ImageRow className="avtarUsrRw" key={`avtar-${i}`}>
                                    {map(item, key => (<Wrapper className="avtarUsrWrap" active={key == avatarSelected}
                                        key={key}
                                        onClick={() => {
                                            if (!loader) {
                                                updateAvatar(key)
                                            }
                                        }}>
                                        {loader && key == avatarSelected ? <LoaderWrapper> <Loading size={25} /> </LoaderWrapper> : null}
                                        <Avatar src={AVATARS[key]} size={{ xs: 84, sm: 90, xl: 150, lg: 100, xxl: 160, md: 120 }} />
                                    </Wrapper>))}
                                </ImageRow>)
                                )}
                            </UserArea>
                            <div className='avtarSiteLogo'>
                              <img src={OneWayLogoSvg} alt="One Way Education" title="One Way Education" />
                            </div>
                        </UserPopUpArea>
                    </UserModal>
                </StyledModal>

                {/* Theme Modal */}
                <StyledModal
                    open={thememodal}
                    onClose={() => setThemeModal(false)}
                    className="avtarModl avtarModlAddOns themeModlCstm">
                    <UserModal className="avtarUsrModl">
                        <UserPopUpArea className="avtarUsrArea">
                            <StyledTypography variant="h4">
                                Please select your Theme:
                            </StyledTypography>
                            <img src={crossCircleSvg} alt="Close" title="Close" onClick={() => setThemeModal(false)} className='avtarMdlClose' />
                            <UserArea className="avtarUsrImg">
                                <div>
                                    <ul className="assignColor">
                                        {map(THEME, _color => (<ColorCircle key={_color} bgColor={_color} active={_color === theme} onClick={() => { onThemeUpdate(_color) }}>
                                            {themeLoader && _color == theme ? <LoaderWrapper> <Loading size={25} /> </LoaderWrapper> : null}
                                        </ColorCircle>))}
                                    </ul>
                                </div>
                            </UserArea>
                             <div className='avtarSiteLogo'>
                              <img src={OneWayLogoSvg} alt="One Way Education" title="One Way Education" />
                            </div>
                        </UserPopUpArea>
                    </UserModal>
                </StyledModal>

                {/* Co-teacher Modal */}
                <StyledModal
                    open={coteacherModal}
                    onClose={() => setCoteacherModal(false)}
                    className="avtarModl"
                >
                    <UserModal className="avtarUsrModl" style={{ minWidth: "30vw", width: "auto" }}>
                        <UserPopUpArea className="avtarUsrArea">
                            <StyledTypography variant="h4">
                                Co-teachers:
                            </StyledTypography>
                            <CloseBtn onClick={() => setCoteacherModal(false)}>
                                <Close style={{ color: COLOR.white, fontWeight: "bolder", fontSize: 25 }} />
                            </CloseBtn>
                            <UserArea className="avtarUsrImg" style={{ justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }}>
                                {map(classTeachers, (cls, i) => (<CoTeacherText key={cls.id}>({i + 1}) {cls.firstName || ""} {cls.lastName || ""}</CoTeacherText>))}
                            </UserArea>
                            <LogoBottomRow>
                                <Logo src={TransparentLogoWhite} />
                            </LogoBottomRow>
                        </UserPopUpArea>
                    </UserModal>
                </StyledModal>

                <DeleteModal
                    deleteToggle={archiveToggle}
                    setDeleteToggle={setArchiveToggle}
                    loading={onArchiveLoading}
                    message={
                        <>
                            Are you sure you want to {classInfo.archived ? "Show" : "Hide"}{" "}
                            <span style={{ 
                                color: '#000', 
                                padding: '2px 6px', 
                                borderRadius: '3px',
                                fontWeight: '600'
                            }}>
                                {classInfo.displayName}
                            </span>{" "}
                            class?
                        </>
                    }
                    buttonTitle={classInfo.archived ? "Show" : "Hide"}
                    onDelete={onArchiveDone}
                    colorSchema={classInfo.archived ? "primary" : "secondary"}
                />
                <div className="noteLinks">
                    <Row>
                        <Col span={6} style={{ marginBottom: 0 }}>
                            {classTeachers.length > 0 ? <>
                                <CoteacherTitle onClick={() => setCoteacherModal(true)}>Co-teacher</CoteacherTitle>
                            </> : null}
                        </Col>
                        <Col span={18} style={{ marginBottom: 0 }}>
                            <ul>
                                {!classInfo.archived && <li onClick={redirectToHome}><a style={{position:'relative'}}> {classLoader ? (<LoaderWrapper style={{top:0,left:0}}> <Loading size={25} /> </LoaderWrapper>) : null} Home</a></li>}
                                {!classInfo.archived && <li onClick={redirectToGradeBook}><a style={{position:'relative'}}>{classGeadeLoader ? (<LoaderWrapper style={{top:0,left:20}}> <Loading size={25} /> </LoaderWrapper>) : null} Gradebook</a></li>}
                                <li onClick={onArchiveClass}><a>{!classInfo.archived ? "Hide" : "Show"}</a></li>
                            </ul>

                        </Col>
                    </Row>
                </div>
            </div>
        </OuterWrapper>
    )
}